import * as React from 'react'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'

import { configShouldUseCustomBackgroundSelector } from 'embed/selectors/config'
import { Config, Theme, THEME_QUERY_PARAM_PREFIX } from '@evenfinancial/even-ts-static'
import { MultiProductState } from 'embed/reducers'

export interface Props {
  children: (theme: Theme) => React.ReactNode
  theme: Theme
}

class ThemeConsumer extends React.PureComponent<Props> {
  public render() {
    const { children, theme } = this.props

    return <React.Fragment>{children(theme)}</React.Fragment>
  }
}

const themeSelector = createSelector(
  (state: MultiProductState) => state.config,
  configShouldUseCustomBackgroundSelector,
  (config, enableCustomBackground) => {
    // Take all config params and filter to only the ones that match actual
    // theme params, (formatted like e.g. theme.colorSecondary)
    const themeConfig = Object.keys(config ?? {}).reduce((acc, key) => {
      if (key.startsWith(THEME_QUERY_PARAM_PREFIX)) {
        acc[key] = config[key]
      }
      return acc
    }, {}) as Partial<Config>
    // Remove the namespace from the query param key (theme.colorSecondary => colorSecodary)
    const theme = Object.fromEntries(
      Object.entries(themeConfig).map(([key, value]) => [key.replace(THEME_QUERY_PARAM_PREFIX, ''), value]),
    ) as Partial<Theme>

    theme.backdropStyles = enableCustomBackground
      ? theme.backdropStyles
      : { backgroundColor: theme.colorBackgroundSecondary }
    theme.boxStyles = enableCustomBackground ? { border: 'none', borderRadius: 'unset', boxShadow: 'none' } : {}

    return theme as Theme
  },
)

const mapStateToProps = (state) => ({
  theme: themeSelector(state),
})

export default connect(mapStateToProps)(ThemeConsumer)
